import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeArrowLeft extends Shape {
    width = 200;
    height = 182;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = height / 2 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 3 + ((2 / 3) * width) / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 3, y);
        canv.ctx.lineTo(x + width / 3, y + height / 4);
        canv.ctx.lineTo(x + width, y + height / 4);
        canv.ctx.lineTo(x + width, y + (height * 3) / 4);
        canv.ctx.lineTo(x + width / 3, y + (height * 3) / 4);
        canv.ctx.lineTo(x + width / 3, y + height);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M13.5 2.22684V4.5C13.5 5.05228 13.9477 5.5 14.5 5.5H23C23.5523 5.5 24 5.94772 24 6.5V17.5C24 18.0523 23.5523 18.5 23 18.5H14.5C13.9477 18.5 13.5 18.9477 13.5 19.5V21.7732C13.5 22.636 12.4805 23.0938 11.8356 22.5206L0.840836 12.7474C0.393321 12.3496 0.393321 11.6504 0.840836 11.2526L11.8356 1.47943C12.4805 0.906189 13.5 1.364 13.5 2.22684Z"/>
            </svg>
        `;
    }
}
